// LANGUAGES

export const LANGUAGES = [
  {
    label: 'English',
    key: 'english',
    locale: 'en'
  },
  {
    label: 'Russian',
    key: 'russian',
    locale: 'ru'
  },
  {
    label: 'German',
    key: 'german',
    locale: 'de'
  }
  // {
  //   label: 'Ukrainian',
  //   key: 'ukrainian',
  //   locale: 'ua'
  // }
];

// GANDER

export const GANDER_MALE_VALUE = 1;
export const GANDER_FEMALE_VALUE = 2;

export const GENDERS = [
  {
    value: GANDER_MALE_VALUE,
    label: 'male'
  },
  {
    value: GANDER_FEMALE_VALUE,
    label: 'female'
  }
];

export const GENDERS_VALUES: { [key: number]: string } = {
  [GANDER_MALE_VALUE]: 'male',
  [GANDER_FEMALE_VALUE]: 'female'
};

export type GenderKeyType = keyof typeof GENDERS_VALUES;

// PLANS

export const PLAN_TYPE_VALUES = {
  video_call: 1,
  report: 2
};

export const PLAN_TYPE_LABELS = {
  1: 'video_call',
  2: 'report'
};

export const PLAN_TYPES = [
  {
    value: PLAN_TYPE_VALUES.video_call,
    label: 'video_call'
  },
  {
    value: PLAN_TYPE_VALUES.report,
    label: 'report'
  }
];
